import type { Components, Theme } from "@mui/material";

export const formLabelTheme: Components<Theme>["MuiFormLabel"] = {
  styleOverrides: {
    root: ({ theme }) => ({
      "&.Mui-error": {
        color: theme.palette.text.secondary,
      },
      "&.Mui-focused": {
        color: theme.palette.text.secondary,
      },
    }),
  },
};
